import React from 'react';
import { COMPANY } from '../data/mock';

export default function Privacy() {
  return (
    <div className="bg-white">
      <div className="bg-slate-50 border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 text-center">
          <h1 className="font-serif text-4xl md:text-5xl font-semibold text-slate-900">Privacy Policy</h1>
          <p className="mt-2 text-slate-600">Last updated: January 2025</p>
        </div>
      </div>

      <article className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <p className="text-slate-600">
          {COMPANY.corp} (“we,” “us,” or “our”) respects your privacy. This Privacy Policy explains how we
          collect, use, and protect information when you visit {COMPANY.name} or make a purchase.
        </p>

        <h2 className="font-serif text-2xl text-slate-900 mt-8 mb-3">Information We Collect</h2>
        <p className="text-slate-600">
          We collect information you provide directly, such as your name, shipping address, email address, phone
          number, and payment details when you place an order. We also collect limited technical information through
          cookies, including browser type and pages visited, to improve your experience.
        </p>

        <h2 className="font-serif text-2xl text-slate-900 mt-8 mb-3">How We Use Your Information</h2>
        <ul className="list-disc pl-6 text-slate-600 space-y-1">
          <li>Process orders and deliver products</li>
          <li>Provide customer service and respond to inquiries</li>
          <li>Send transactional emails about your orders</li>
          <li>Improve our website, products, and services</li>
          <li>Comply with legal obligations</li>
        </ul>

        <h2 className="font-serif text-2xl text-slate-900 mt-8 mb-3">Sharing Your Information</h2>
        <p className="text-slate-600">
          We do not sell your personal information. We share information only with trusted service providers (such
          as shipping carriers and payment processors) who help us operate our business, and only as necessary to
          fulfill your order.
        </p>

        <h2 className="font-serif text-2xl text-slate-900 mt-8 mb-3">Data Security</h2>
        <p className="text-slate-600">
          We implement industry-standard safeguards to protect your information. However, no method of transmission
          over the internet is completely secure, and we cannot guarantee absolute security.
        </p>

        <h2 className="font-serif text-2xl text-slate-900 mt-8 mb-3">Your Choices</h2>
        <p className="text-slate-600">
          You may request access, correction, or deletion of your personal information at any time by contacting
          us. You can also opt out of marketing emails by following the unsubscribe link in any message.
        </p>

        <h2 className="font-serif text-2xl text-slate-900 mt-8 mb-3">Contact</h2>
        <p className="text-slate-600">
          Questions about this Privacy Policy? Reach us at {COMPANY.email} or {COMPANY.phone}. Mailing address:{' '}
          {COMPANY.address}.
        </p>
      </article>
    </div>
  );
}
